import CloudStorage from "./components/CloudStorage";
import DateStarted from "./components/DateStarted";
import Notes from "./components/Notes";

const Others = ({ data, setData }) => {
  return (
    <>
      <div className="p-5">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-500">Others</p>
            <span className="text-xs text-gray-400">Additional Settings</span>
          </div>
        </div>
      </div>
      <DateStarted data={data} setData={setData} />
      <CloudStorage data={data} setData={setData} />
      <Notes data={data} setData={setData} />
    </>
  );
};

export default Others;
